import { jsxs as U, Fragment as R, jsx as D } from "react/jsx-runtime";
import { useState as H } from "react";
import { F as v, S as K, I as q, a as z, C as E } from "./InfoCardGrid-CVf_t4co.js";
import { I as J, L as Q, C as k } from "./CardCarousel-pbnHoBrL.js";
import { g as V } from "./link-utils-yTXHuXGc.js";
import { H as W } from "./HeroBanner-v7s2AnB2.js";
import { S as X } from "./Section-DOeCOW54.js";
import { G as x } from "./Gap-BresIL53.js";
const Y = {
  "details-page": "elo-details-page"
}, M = (u) => u.map(
  ({
    id: l,
    name: s,
    surfaceArea: p,
    floor: g,
    type: m,
    image: t,
    status: b,
    district: i,
    city: T,
    floorLabel: y
  }) => ({
    title: `${m}, ${s}`,
    subtitle: `${g} ${y}, ${i}, ${T}`,
    squareFeet: p.toString(),
    image: t,
    tagText: b,
    url: V(l)
  })
), I = ({
  floatButtonText: u,
  heroBanner: l,
  spaceIntroduction: s,
  largeImage: p,
  infoCardGrid: g,
  infoBanner: m,
  contactBanner: t,
  officeCardFirst: b,
  officeCardSecond: i,
  linkTo3DModel: T
}) => {
  const [y, L] = H(!1), A = (l == null ? void 0 : l.imageUrl) && (l == null ? void 0 : l.title) && (l == null ? void 0 : l.subtitle) && (l == null ? void 0 : l.primaryButtonText) && (l == null ? void 0 : l.secondaryButtonText) && (l == null ? void 0 : l.carouselImages), O = (s == null ? void 0 : s.lat) && (s == null ? void 0 : s.lng) && (s == null ? void 0 : s.label) && (s == null ? void 0 : s.shortDescription), $ = (g == null ? void 0 : g.heading) && (g == null ? void 0 : g.infoCardData), j = (b == null ? void 0 : b.officeCardData) && (b == null ? void 0 : b.officeCardData.length) > 0 && (b == null ? void 0 : b.title), w = (m == null ? void 0 : m.title) && (m == null ? void 0 : m.src) && (m == null ? void 0 : m.subtitle), N = (i == null ? void 0 : i.officeCardData) && (i == null ? void 0 : i.title) && (i == null ? void 0 : i.officeCardData.length) > 0, P = (t == null ? void 0 : t.title) && (t == null ? void 0 : t.name) && (t == null ? void 0 : t.phoneNumber);
  return /* @__PURE__ */ U(R, { children: [
    A && /* @__PURE__ */ D(
      W,
      {
        imageUrl: l.imageUrl,
        imageAlt: l.imageAlt,
        statusText: l.statusText,
        title: l.title,
        secondaryTitle: l.secondaryTitle,
        isDark: !0,
        subtitle: l.subtitle,
        secondarySubtitle: l.secondarySubtitle,
        primaryButtonText: l.primaryButtonText,
        secondaryButtonText: l.secondaryButtonText,
        anchorLink: "#space-introduction",
        onOpenModal: function() {
          console.error("Function not implemented.");
        },
        carouselImages: l.carouselImages
      }
    ),
    u && /* @__PURE__ */ D(v, { href: "#contact", iconLeft: "Contact", children: u }),
    /* @__PURE__ */ U(X, { className: Y["details-page"], children: [
      O && /* @__PURE__ */ D(
        K,
        {
          type: "office",
          lat: s.lat,
          lng: s.lng,
          googleMapsApiKey: s.googleMapsApiKey,
          label: s.label,
          shortDescription: s.shortDescription,
          open3DModelButtonText: s.open3DModelButtonText,
          downloadFloorPlanButtonText: s.downloadFloorPlanButtonText,
          showModal: !!T,
          openModal: () => {
            L(!0);
          },
          downloadableImage: p == null ? void 0 : p.imageUrl
        }
      ),
      T && /* @__PURE__ */ D(
        J,
        {
          src: T,
          isOpen: y,
          onClose: () => {
            L(!1);
          },
          modalAriaDescription: "3D Model",
          modalAriaTitle: "3D Model"
        }
      ),
      (p == null ? void 0 : p.imageUrl) && /* @__PURE__ */ D(Q, { imageUrl: p.imageUrl, alt: p.alt }),
      /* @__PURE__ */ D(x, {}),
      $ && /* @__PURE__ */ D(
        q,
        {
          heading: g.heading,
          infoCardData: g.infoCardData
        }
      ),
      /* @__PURE__ */ D(x, {}),
      j && /* @__PURE__ */ D(
        k,
        {
          officeCardData: M(b.officeCardData),
          title: b.title
        }
      ),
      /* @__PURE__ */ D(x, {}),
      w && /* @__PURE__ */ D(
        z,
        {
          variant: "secondary",
          alignLeft: !1,
          src: m.src,
          subtitle: m.subtitle,
          title: m.title,
          descriptionTitle: m.descriptionTitle,
          description: m.description,
          linkLabel: m.linkLabel,
          linkUrl: m.linkUrl,
          iconLeft: m.iconLeft,
          iconRight: m.iconRight
        }
      ),
      /* @__PURE__ */ D(x, {}),
      N && /* @__PURE__ */ D(
        k,
        {
          officeCardData: M(i.officeCardData),
          title: i.title
        }
      ),
      P && /* @__PURE__ */ D(
        E,
        {
          variant: "transparent",
          src: t.src,
          subtitle: t.subtitle,
          title: t.title,
          name: t.name,
          jobTitle: t.jobTitle || "",
          phoneNumber: t.phoneNumber,
          linkLabel: t.linkLabel,
          linkUrl: t.linkUrl,
          iconLeft: t.iconLeft,
          iconRight: t.iconRight,
          email: t.email
        }
      )
    ] })
  ] });
};
export {
  I as DetailsPage
};
